import { useResponsive } from './useResponsive';
import { useStore } from '../zustand/stores';

export const useIsSitePickerEnabled = () => {
  const { isMobile, isTablet } = useResponsive();
  const { isAiServicesDisabled } = useStore((state) => state.featureTogglesSlice);

  if (isAiServicesDisabled || isMobile || isTablet) {
    return false;
  }

  return true;
};
